module.exports = __webpack_public_path__ + "img/sw-logo-xs.1deae5c5.webp";